import { FontStacks, FontFamilyIds } from './constants';
// We used to save the entire font stack, i.e. 'Arial,Helvetica,sans-serif', as the value for fontFamily,
// before we switched to use constants.
// This is to convert font stacks to constants for backward compatibility.
const getFontFamilyId = ({ fontFamily, fontStacks = FontStacks, customFonts = {} }) => {
    if (customFonts[fontFamily] || fontStacks[fontFamily] || fontFamily === 'primary' || fontFamily === 'secondary') {
        return fontFamily;
    }
    return Object.keys(fontStacks).find(key => fontStacks[key] === fontFamily) || FontFamilyIds.Arial;
};
export default getFontFamilyId;
